export default "__VITE_ASSET__BVRxd5CK__"